import { LayoutTokenClasses } from '../ModularTypes/LayoutSettings';

type ClassValue = string | undefined | null;

export class LayoutClassBuilder {
  static build(props: LayoutTokenClasses): string {
    const {
      layout,
      gridTemplate,
      flexDirection,
      gap,
      justifyContent,
      justifyItems,
      alignContent,
      alignItems,
      background,
    } = props;

    return [
      'layout-root',
      layout,

      this.prefixed('grid-template', gridTemplate),
      this.prefixed('flex-direction', flexDirection),
      this.prefixed('gap', gap),
      this.prefixed('bg', background),

      this.prefixed('justify-content', justifyContent),
      this.prefixed('justify-items', justifyItems),
      this.prefixed('align-content', alignContent),
      this.prefixed('align-items', alignItems),
    ]
      .filter(this.isValid)
      .join(' ');
  }

  static isValid(value: ClassValue): value is string {
    return typeof value === 'string' && value.trim() !== '';
  }

  static prefixed(prefix: string, value: ClassValue): string | null {
    return value ? `${prefix}-${value}` : null;
  }
}
